/**
 * ============================================
 * Professional Loading Spinner Component
 * ============================================
 * 
 * Reusable loading spinner used across all pages
 */
import React from 'react';
import NavigationBar from '../layout/NavigationBar';
import Footer from '../layout/footer';

const LoadingSpinner = ({ message = 'Loading...', showLayout = true }) => {
  const spinnerContent = (
    <div style={{ textAlign: 'center' }}>
      {/* Professional E-commerce Spinner */}
      <div style={{
        position: 'relative',
        width: '80px',
        height: '80px',
        margin: '0 auto 20px'
      }}>
        {/* Outer ring */}
        <div style={{
          position: 'absolute',
          width: '80px',
          height: '80px',
          border: '3px solid #f0f0f0',
          borderTop: '3px solid #1E5B3A',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        {/* Inner ring */}
        <div style={{
          position: 'absolute',
          width: '60px',
          height: '60px',
          top: '10px',
          left: '10px',
          border: '3px solid #f0f0f0',
          borderBottom: '3px solid #2E7D4F',
          borderRadius: '50%',
          animation: 'spin 1.5s linear infinite reverse'
        }}></div>
        {/* Center dot */}
        <div style={{
          position: 'absolute',
          width: '12px',
          height: '12px',
          top: '34px',
          left: '34px',
          backgroundColor: '#1E5B3A',
          borderRadius: '50%',
          animation: 'pulse 1.5s ease-in-out infinite'
        }}></div>
      </div>
      <p style={{
        fontSize: '16px',
        color: '#1E5B3A',
        fontWeight: '600',
        marginTop: '10px'
      }}>
        {message}
      </p>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes pulse {
            0%, 100% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.2); opacity: 0.7; }
          }
        `}
      </style>
    </div>
  );

  if (!showLayout) {
    return spinnerContent;
  }

  return (
    <div className="wrapper" id="root">
      <header>
        <NavigationBar />
      </header>
      <div
        className="content-wrapper d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        {spinnerContent}
      </div>
      <Footer />
    </div>
  );
};

export default LoadingSpinner;
